import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    endTime: String,
    expiredUrl: String,
  };
  static targets = ["display"];

  connect() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  update() {
    const end = new Date(this.endTimeValue).getTime();
    const now = new Date().getTime();
    const distance = end - now;

    if (distance <= 0) {
      clearInterval(this.timer);
      this.handleExpiration();
      return;
    }

    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.displayTarget.textContent = `${this.format(minutes)}:${this.format(
      seconds
    )}`;
  }

  handleExpiration() {
    if (this.hasExpiredUrlValue) {
      window.location.href = this.expiredUrlValue;
    } else {
      this.displayTarget.textContent = "00:00";
    }
  }

  format(num) {
    return num.toString().padStart(2, "0");
  }
}
